<vo-smart-footer
  *ngIf="footer"
  [copyright]="footer.copyrightText1 + ' ' + footer.copyrightText2"
  [links]="footer.link"
  [logo]="(footer.logo.media[0] | mediaSrcStrapi : mediaBase)!"
  [logoUrl]="footer.logo.url"
></vo-smart-footer>
